import { render, staticRenderFns } from "./save-bar.vue?vue&type=template&id=574ca221&lang=pug&"
import script from "./save-bar.vue?vue&type=script&lang=js&"
export * from "./save-bar.vue?vue&type=script&lang=js&"
import style0 from "./save-bar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports